const DEFAULT_RETURN_PATH = "/manage/";

type QUERY_PARAMS_MAP = Record<string, Set<string>>;

const ALLOWED_QUERY_PARAMS: QUERY_PARAMS_MAP = {
  sync: new Set(["true", "false"]),
  tab: new Set(["local", "github", "manual"]),
  ci: new Set(["true"]),
  type: new Set(["github"]),
  installed: new Set(["github", "gitlab"]),
};

export const selectSafeParams = (paramsString: string): string => {
  const unsafeParams = new URLSearchParams(paramsString);
  const safeParams = new URLSearchParams();
  let hasSafeParam = false;
  for (const [key, value] of Array.from(unsafeParams)) {
    if (ALLOWED_QUERY_PARAMS[key] && ALLOWED_QUERY_PARAMS[key].has(value)) {
      safeParams.append(key, value);
      hasSafeParam = true;
    }
  }
  const safeParamsString = safeParams.toString();
  const q = hasSafeParam ? "?" : "";
  return q + safeParamsString;
};

export const getRedirectPath = (authState: string | null): string => {
  // Remove portion of URI that is used for authentication and decode ascii chars like / and ?
  const untrustedRedirectPath = decodeURIComponent(
    (authState ?? "").split("-").slice(1).join("-")
  );
  if (untrustedRedirectPath.length === 0) return DEFAULT_RETURN_PATH;

  // if login fails once and succeeds on the 2nd try
  // avoid going back to the 1st login attempt's error page
  if (untrustedRedirectPath === "/fatal-error") return DEFAULT_RETURN_PATH;

  // make sure we only redirect within our own domain to avoid open-redirect attacks
  // security important: do not modify without care and extra code review
  const url = new URL(window.location.href);
  const [base, params] = untrustedRedirectPath.split("?");
  const safeParams = selectSafeParams(params);
  url.pathname = base;
  url.search = safeParams;
  const safeRedirectPath = `${url.pathname}${url.search}`;
  return safeRedirectPath;
};
